export { default as DashboardStatusDataCircles } from './DashboardStatusDataCircles';

export type {
  DashboardStatusDataCirclesComponent,
  DashboardStatusDataCirclesProps,
} from './DashboardStatusDataCircles.type';
